import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FooterWrapper',
  setup(__props) {

const showAccordion = ref<string>();
const maxAccordionHeight = ref<number>(0);

const getAccordionContentHeight = (sourceElement: HTMLElement | null): number => {
  const accordionContent = sourceElement?.closest(".accordion")?.querySelector(".accordion__content");
  return accordionContent?.scrollHeight ?? 0;
};

const onOpenAccordion = (ev: Event, id: string) => {
  if (showAccordion.value == id) {
    showAccordion.value = undefined;
  } else {
    showAccordion.value = id;
  }

  if (showAccordion.value != undefined) {
    maxAccordionHeight.value = getAccordionContentHeight(ev.target as HTMLElement);
  } else {
    maxAccordionHeight.value = 0;
  }
};

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    showAccordion: showAccordion.value,
    maxAccordionHeight: maxAccordionHeight.value,
    onOpenAccordion: onOpenAccordion
  })
}
}

})